import { ConnectError } from '@bufbuild/connect';
import { FormattedMessage } from 'react-intl';

import { getErrorMessage } from './getErrorMessage';
import { toastCaller } from './Toast';

let errorDebounceTimer: ReturnType<typeof setTimeout> | null = null;

export const errorToastCaller = (error: ConnectError) => {
  const errorMessage = getErrorMessage(error);

  if (errorDebounceTimer) {
    clearTimeout(errorDebounceTimer);
  }

  errorDebounceTimer = setTimeout(() => {
    toastCaller({
      type: 'error',
      heading: <FormattedMessage id="error.heading" defaultMessage="Error" />,
      message: errorMessage,
      autoClose: 10000,
    });
  }, 100);
};
